import React, { useState } from 'react'
import { Button, Card, Modal, QRCode, Row } from 'antd'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import CONSTANTS from '../../../util/constant/CONSTANTS'
import Heading from '../../../component/common/Heading'
import CRUDComponent from '../../../component/common/CRUD-Component'
import { COPY_UNIQUE_ID, DEVICE, DEVICE_CONNECTION, DEVICE_STATUS } from '../../../util/functions'

const PetDevice = () => {
    const [qrData, setQrData] = useState(null)
    const navigate = useNavigate();

    const downloadQRCode = async () => {
        const canvas = document.getElementById('myqrcode')?.querySelector('canvas');

        if (canvas) {
            // Wait for the QR code to render
            await new Promise(resolve => setTimeout(resolve, 500)); // Adjust the delay as needed

            const url = canvas.toDataURL();
            const a = document.createElement('a');
            a.download = 'QRCode.png';
            a.href = url;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    };

    // console.log(userFeedBackApi);
    return (
        <>
            <Card className="mt-5">
                <Heading>Device List</Heading>

                <Row>
                    <CRUDComponent
                        GET={{
                            API: CONSTANTS.API.Pet_Device.getAll,
                            DataModifier: (res, API, Setrefresh) => {
                                // console.log(res, "GET ALL ABCD");
                                return res?.map(data => {
                                    return {
                                        ...data,
                                        no: `P${data?.id.toString().padStart(7, "0")}`,
                                        dob: moment(data?.dob).format("DD MMM YYYY"),
                                        name: data?.pet?.name,
                                        image: data?.pet?.image,
                                        view: {
                                            id: data?.id,
                                            onClick: () => {
                                                navigate(`/app/pets/${data?.pet?.id}`)
                                            }
                                        },

                                        // Device
                                        deviceTypeId: data?.device ? DEVICE[data?.device?.deviceTypeId] : (data?.pet?.petDeviceInfos?.length > 0 ? DEVICE[data?.pet?.petDeviceInfos[0]?.device?.deviceTypeId] : '-'),
                                        deviceStatus: data?.device ? DEVICE_STATUS[data?.device?.isActive] : (data?.petDeviceInfos?.length > 0 ? DEVICE_STATUS[data?.pet?.petDeviceInfos[0]?.device?.isActive] : '-'),
                                        Did: data?.device?.DID ? COPY_UNIQUE_ID(data?.device?.DID, 'Device') : (data?.pet?.petDeviceInfos?.length > 0 ? COPY_UNIQUE_ID(data?.pet?.petDeviceInfos?.[0]?.device?.DID, "Device") : '-'),
                                        // Did: data?.device?. ? data?.device?.DID : (data?.pet?.petDeviceInfos?.length > 0 ? data?.pet?.petDeviceInfos[0]?.device?.DID : '-'),
                                        deviceQR: data?.device ? DEVICE_CONNECTION[true] : ((data?.pet?.petDeviceInfos?.length > 0) ? (data?.pet?.petDeviceInfos[0]?.scanQr ? DEVICE_CONNECTION[true] : DEVICE_CONNECTION[false]) : '-'),
                                        deviceWifi: data?.device ? DEVICE_CONNECTION[true] : ((data?.pet?.petDeviceInfos?.length > 0) ? (data?.pet?.petDeviceInfos[0]?.connectWifi ? DEVICE_CONNECTION[true] : DEVICE_CONNECTION[false]) : '-'),
                                        deviceConnection: data?.device ? 'Connected' : 'Not Connected',
                                        collarId: data?.device ? COPY_UNIQUE_ID(data?.device?.uniqueId, "Collar") : ((data?.pet?.petDeviceInfos?.length > 0) ? COPY_UNIQUE_ID(data?.pet?.petDeviceInfos[0]?.device?.uniqueId, "Collar") : '-'),
                                        qrcode: {
                                            id: data?.id,
                                            isDisable: !data?.device?.DID && !data?.pet?.petDeviceInfos?.[0]?.device?.DID,
                                            onClick: () => {
                                                setQrData({
                                                    deviceDID: data?.device?.DID ? data?.device?.DID : (data?.pet?.petDeviceInfos?.length > 0 ? data?.pet?.petDeviceInfos[0]?.device?.DID : '')
                                                })
                                            }
                                        },




                                        // Feeder Device
                                        feederStatus: data?.pet?.feederConnections?.length > 0 ? DEVICE_STATUS[data?.pet?.feederConnections[0]?.feedar?.isActive] : (data?.pet?.feederDeviceInfos?.length > 0 ? DEVICE_STATUS[data?.pet?.feederDeviceInfos[0]?.feedar?.isActive] : '-'),
                                        feederQR: data?.pet?.feederConnections?.length > 0 ? DEVICE_CONNECTION[true] : ((data?.pet?.feederDeviceInfos?.length > 0) ? (data?.pet?.feederDeviceInfos[0]?.scanQr ? DEVICE_CONNECTION[true] : DEVICE_CONNECTION[false]) : '-'),
                                        feederWifi: data?.pet?.feederConnections?.length > 0 ? DEVICE_CONNECTION[true] : ((data?.pet?.feederDeviceInfos?.length > 0) ? (data?.pet?.feederDeviceInfos[0]?.connectWifi ? DEVICE_CONNECTION[true] : DEVICE_CONNECTION[false]) : '-'),
                                        feederId: data?.pet?.feederConnections?.length > 0 ? COPY_UNIQUE_ID(data?.pet?.feederConnections[0]?.feedar?.uniqueId, "Feeder") : ((data?.pet?.feederDeviceInfos?.length > 0) ? COPY_UNIQUE_ID(data?.pet?.feederDeviceInfos[0]?.feedar?.uniqueId, "Feeder") : '-'),
                                        feederConnection: data?.pet?.feederConnections?.length > 0 ? 'Connected' : 'Not Connected',
                                        feederDID: data?.pet?.feederConnections?.[0]?.feedar?.DID ? COPY_UNIQUE_ID(data?.pet?.feederConnections?.[0]?.feedar?.DID, "Feeder DID") : "-",
                                        feederQrCode: {
                                            id: data?.id,
                                            isDisable: !data?.pet?.feederConnections?.[0]?.feedar?.DID,
                                            onClick: () => {
                                                setQrData({
                                                    feederDID: data?.pet?.feederConnections?.[0]?.feedar?.DID,
                                                })
                                            }
                                        },
                                    }
                                })
                            },
                            column: CONSTANTS.TABLE.SUPPORT_USER_PETS,
                        }}
                        isSearch={true}

                    />
                </Row>

            </Card>
            <Modal
                open={qrData !== null}
                title={<p className="form-modal-head mb25">Generate QR Code</p>}
                okText="Submit"
                centered
                cancelButtonProps={{ style: { display: "none" } }}
                okButtonProps={{ style: { display: "none" } }}
                className="form-modal-title"
                onCancel={() => setQrData(null)}
                onOk={() => setQrData(null)}
            >
                <div className='flex flex-col justify-center items-center ' >
                    <div id="myqrcode">
                        <QRCode

                            value={JSON.stringify(qrData)}
                            bgColor="#fff"
                            style={{
                                marginBottom: 16,
                            }}
                        />
                    </div>
                    <Button type="primary" onClick={downloadQRCode}>
                        Download
                    </Button>

                </div>
            </Modal>
        </>
    )
}

export default PetDevice